var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"text-align":"center","line-height":"100vh"}},[_vm._v(" 页面适配中，请稍候... ")])
}
var staticRenderFns = []

export { render, staticRenderFns }